export const updatePasswordSelector = state => state.api.updatePassword;
